import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.businessCards
)

export const selectBusinessCards = createSelector(
    baseSelector,
    (state) => state.cards
)

export const selectBusinessCardsLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectBusinessCardsFirstLoad = createSelector(
    baseSelector,
    (state) => state.firstLoad
)

export const selectBusinessCardsError = createSelector(
    baseSelector,
    (state) => state.error
)

